(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver_tailwind_scrolling = {

    initScrollingIndicators: function() {
      const scrollableElements = document.querySelectorAll('[data-ptb-scrollable]');

      if (scrollableElements.length < 1) {
        return;
      }

      scrollableElements.forEach((element) => {
        element.addEventListener('scroll', () => {
          this.updateArrowVisibility(element);
        });
      });
    },

    updateArrowVisibility: function(element) {
      const indicator = element.querySelector('[data-ptb-scroll-indicator]');

      if (indicator == null) {
        return;
      }

      const scrollLeft = element.scrollLeft;
      const maxScrollLeft = element.scrollWidth - element.clientWidth;

      if (maxScrollLeft <= 0) {
        indicator.style.opacity = '0';
        return;
      }

      // Fade out indicator when close to right edge
      if (scrollLeft >= maxScrollLeft - 10) {
        indicator.style.opacity = '0';
      } else {
        indicator.style.opacity = '1';
      }
    },

    attach: function (context, settings) {

      $(once('weaver_tailwind_scrolling', 'body', context)).each(function () {
        const weaver_scrolling = Drupal.behaviors.weaver_tailwind_scrolling;

        weaver_scrolling.initScrollingIndicators();
        
        window.addEventListener('resize', weaver_scrolling.initScrollingIndicators());
      });
    }
  };
})(jQuery, Drupal, once);